import React, { useState, useEffect } from 'react';
import { payrollFetch } from './PayrollAuth';
import '../pages/payroll/PayrollTable.css';

const API = '/api/payroll';

const ROLES = [
  { value: 'superadmin',    label: 'Супер Админ',        color: '#7c3aed', bg: '#ede9fe' },
  { value: 'dept_head',     label: 'Начальник отдела',   color: '#065f46', bg: '#d1fae5' },
  { value: 'hotel_manager', label: 'Управляющий отелем', color: '#1d4ed8', bg: '#dbeafe' },
  { value: 'accountant',    label: 'Бухгалтер',          color: '#92400e', bg: '#fef3c7' },
];

const EMPTY = { name: '', email: '', password: '', role: 'hotel_manager', hotel_id: '', department_id: '' };

export default function Users() {
  const [users, setUsers]       = useState([]);
  const [hotels, setHotels]     = useState([]);
  const [depts, setDepts]       = useState([]);
  const [form, setForm]         = useState(EMPTY);
  const [editId, setEditId]     = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [newPass, setNewPass]   = useState('');
  const [showPass, setShowPass] = useState(null);

  useEffect(() => { loadAll(); }, []);

  async function loadAll() {
    const [u, h] = await Promise.all([
      payrollFetch(`${API}/users`).then(r => r.json()),
      payrollFetch(`${API}/hotels-and-depts`).then(r => r.json()),
    ]);
    setUsers(Array.isArray(u) ? u : []);
    setHotels(Array.isArray(h) ? h : (h.hotels || []));
    setDepts(Array.isArray(h) ? [] : (h.departments || []));
  }

  function openNew() { setForm(EMPTY); setEditId(null); setShowForm(true); }

  function openEdit(u) {
    setForm({ name: u.name, email: u.email, password: '', role: u.role, hotel_id: u.hotel_id || '', department_id: u.department_id || '' });
    setEditId(u.id); setShowForm(true);
  }

  async function save() {
    setLoading(true);
    const body = { ...form, hotel_id: form.hotel_id ? parseInt(form.hotel_id) : null, department_id: form.department_id ? parseInt(form.department_id) : null };
    if (editId) {
      if (!body.password) delete body.password;
      await payrollFetch(`${API}/users/${editId}`, { method: 'PATCH', body: JSON.stringify(body) });
    } else {
      await payrollFetch(`${API}/users`, { method: 'POST', body: JSON.stringify(body) });
    }
    setShowForm(false); loadAll(); setLoading(false);
  }

  async function deactivate(id) {
    if (!window.confirm('Деактивировать пользователя?')) return;
    await payrollFetch(`${API}/users/${id}`, { method: 'DELETE' });
    loadAll();
  }

  async function resetPassword(id) {
    if (!newPass) return;
    await payrollFetch(`${API}/users/${id}`, { method: 'PATCH', body: JSON.stringify({ password: newPass }) });
    setShowPass(null); setNewPass(''); alert('Пароль изменён');
  }

  const roleInfo = v => ROLES.find(r => r.value === v) || ROLES[2];

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>Пользователи</h2>
        <button className="btn-primary" onClick={openNew}>+ Добавить</button>
      </div>

      <table className="pt-table">
        <thead>
          <tr><th>Имя</th><th>Email</th><th>Роль</th><th>Объект</th><th>Статус</th><th>Последний вход</th><th></th></tr>
        </thead>
        <tbody>
          {users.length === 0 && <tr><td colSpan={7} style={{ textAlign:'center', color:'#9ca3af', padding:40 }}>Нет пользователей</td></tr>}
          {users.map(u => {
            const ri = roleInfo(u.role);
            return (
              <tr key={u.id}>
                <td><strong>{u.name}</strong></td>
                <td style={{ color:'#6b7280', fontSize:13 }}>{u.email}</td>
                <td><span className="badge" style={{ background: ri.bg, color: ri.color }}>{ri.label}</span></td>
                <td>{u.hotel_name || u.department_name || '—'}</td>
                <td><span className="badge" style={{ background: u.is_active ? '#d1fae5' : '#fee2e2', color: u.is_active ? '#065f46' : '#991b1b' }}>{u.is_active ? 'Активен' : 'Отключён'}</span></td>
                <td style={{ fontSize:12, color:'#9ca3af' }}>{u.last_login ? new Date(u.last_login).toLocaleString('ru') : 'никогда'}</td>
                <td style={{ display:'flex', gap:4 }}>
                  <button className="btn-icon" onClick={() => openEdit(u)}>✏️</button>
                  <button className="btn-icon" onClick={() => { setShowPass(u.id); setNewPass(''); }}>🔑</button>
                  {u.is_active && <button className="btn-icon danger" onClick={() => deactivate(u.id)}>✕</button>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>{editId ? 'Редактировать' : 'Новый пользователь'}</h3>
              <button className="btn-icon" onClick={() => setShowForm(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Имя *</label>
                <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Иванов Иван" />
              </div>
              <div className="form-row">
                <label>Email *</label>
                <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="ivan@nomera.ru" disabled={!!editId} />
              </div>
              {!editId && (
                <div className="form-row">
                  <label>Пароль *</label>
                  <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="минимум 6 символов" />
                </div>
              )}
              <div className="form-row">
                <label>Роль *</label>
                <select value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
                  {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Отель</label>
                <select value={form.hotel_id} onChange={e => setForm(f => ({ ...f, hotel_id: e.target.value, department_id: '' }))}>
                  <option value="">— не привязан —</option>
                  {hotels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Подразделение</label>
                <select value={form.department_id} onChange={e => setForm(f => ({ ...f, department_id: e.target.value, hotel_id: '' }))}>
                  <option value="">— не привязан —</option>
                  {depts.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                </select>
              </div>
              <div style={{ background:'#f9fafb', borderRadius:8, padding:'12px 16px', fontSize:13, color:'#6b7280' }}>
                <strong>Права:</strong> {form.role === 'superadmin' && '✅ Полный доступ'}{form.role === 'dept_head' && '✅ Все отели своего подразделения'}{form.role === 'hotel_manager' && '✅ Табель + штрафы + ведомость своего отеля'}{form.role === 'accountant' && '✅ Просмотр ведомостей и статистики'}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setShowForm(false)}>Отмена</button>
              <button className="btn-primary" onClick={save} disabled={loading || !form.name || !form.email || (!editId && !form.password)}>
                {loading ? 'Сохраняем...' : 'Сохранить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPass && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth:400 }}>
            <div className="modal-header">
              <h3>Сменить пароль</h3>
              <button className="btn-icon" onClick={() => setShowPass(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Новый пароль</label>
                <input type="password" value={newPass} onChange={e => setNewPass(e.target.value)} placeholder="минимум 6 символов" autoFocus />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setShowPass(null)}>Отмена</button>
              <button className="btn-primary" onClick={() => resetPassword(showPass)} disabled={newPass.length < 6}>Сохранить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
